import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { questionsListActions } from '../../../../core/questions-list';
import { ModalReportTT } from './ModalReportTT';
import { QuadrantList } from './QuadrantList';

export const ReportTT = ({ questions_list, user_finded, showAllItems = false }) => {
    const dispatch = useDispatch()
    const questions = useSelector(state => state.questions);

    useEffect(() => {
        if (questions && !questions.isPending && !questions.id) dispatch(questionsListActions.loadQuestions())
    }, [dispatch, questions])

    questions_list = useSelector(state => state.questions)

    const [modal, setModal] = useState(false);
    const [current_item, setCurrentItem] = useState(null);
    let image_bg = useRef();

    const user = useSelector(state => state.user );

    const [lengthItems, setLengthItems] = useState({
        Analytic: 0,
        Innovative: 0,
        Procedural: 0,
        Relational: 0,
        All: 0
    })

    useEffect(() => {
        if (!user_finded) {
            user.talents && user.talents.forEach(quadrant => {
                setValue(quadrant.quadrant, quadrant.items.length)
            })
        }
    }, [user.talents])

    useEffect(() => {
        if (user_finded) {
            user_finded.talents && user_finded.talents.forEach(quadrant => {
                setValue(quadrant.quadrant, quadrant.items.length)
            })
        }
    }, [user_finded])

    const setValue = (name, value) => {
        setLengthItems({
            ...lengthItems,
            [name]: value
        })
    }

    const toggle = (key) => {
        setModal(!modal)
        setCurrentItem(questions_list.quadrants.find(item => item.name === key))
    }

    return (
        <>
            <div className="graphic-map graphic-map-sm mx-auto">
                <div className="graphic-map-list overflow-hidden mx-auto mb-2">
                    {/* home */}
                    <QuadrantList user={user_finded ? user_finded : user} toggle={toggle} image_bg={image_bg} />
                </div>
            </div >

            <ModalReportTT
                showAllItems={showAllItems}
                modal={modal}
                toggle={toggle}
                current_item={current_item}
                user={user_finded ? user_finded : user}
            />

        </>
    )
}

export default ReportTT